export enum TransactionSubStatusEnum {
  approved = 'APPROVED', declined = 'DECLINED', approvalPending = 'PENDING_APPROVAL'
}

export const TransactionSubStatuses = [
  { id: TransactionSubStatusEnum.approved, name: TransactionSubStatusEnum.approved },
  { id: TransactionSubStatusEnum.declined, name: TransactionSubStatusEnum.declined },
  { id: TransactionSubStatusEnum.approvalPending, name: TransactionSubStatusEnum.approvalPending },
]